import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import s from './Micro.module.scss'

function Micro({ className, children, bold, muted, inline, ...props }) {
  const classes = classnames(s.micro, className, {
    [s.bold]: bold,
    [s.muted]: muted,
    [s.inline]: inline
  })

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  )
}

Micro.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  bold: PropTypes.bool,
  muted: PropTypes.bool,
  inline: PropTypes.bool
}

Micro.defaultProps = {
  className: null,
  children: null,
  bold: false,
  muted: false,
  inline: false
}

export default Micro
